﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as api from "~base/Services/API";
import type { ConsilioApiToken } from "~base/Services/API/AuthToken";

//-------------------------------------------------------------------------------------
// Http Contract
//-------------------------------------------------------------------------------------

const uri = (): string => {
    const uri = "api/sopnl/v1/selfservice/login";

    return uri;
};

const method = "POST";

//-------------------------------------------------------------------------------------
// Types
//-------------------------------------------------------------------------------------

export type PostSelfServiceLoginRegistrationResponseSuccess = {
    HasError: false;

    LoginToken: ConsilioApiToken;
};

export type PostSelfServiceLoginRegistrationResponseFailure = {
    HasError: true;

    Errors: PostSelfServiceLoginRegistrationResponseError[];
};

export interface PostSelfServiceLoginRegistrationResponseError {
    Field: string;
    Message: string;
    MessageArguments: string[];
}

export type PostSelfServiceLoginRegistrationResponse =
    | PostSelfServiceLoginRegistrationResponseSuccess
    | PostSelfServiceLoginRegistrationResponseFailure;

export interface PostSelfServiceLoginRegistrationRequest {
    Locale: string;

    DomainAccessKey: string;
    DomainAccessCode: string;

    HasAcceptedToS: boolean;
}

export interface PostSelfServiceLoginRegistrationProps extends api.ApiHookBaseProps<
    PostSelfServiceLoginRegistrationRequest,
    PostSelfServiceLoginRegistrationResponse,
    unknown
> {}

//-------------------------------------------------------------------------------------
// API Hook
//-------------------------------------------------------------------------------------

export function usePostSelfServiceLoginRegistration(
    props: PostSelfServiceLoginRegistrationProps
): [
    boolean,
    (data: PostSelfServiceLoginRegistrationRequest) => Promise<unknown>,
] {
    const apiParams: api.ApiHookProps<
        PostSelfServiceLoginRegistrationRequest,
        PostSelfServiceLoginRegistrationResponse,
        unknown
    > = {
        ...props,
        uri: uri(),
        method: method,
    };

    const [loading, invoker] = api.useApi<
        PostSelfServiceLoginRegistrationRequest,
        unknown,
        unknown
    >(apiParams);
    return [
        loading,
        (data: PostSelfServiceLoginRegistrationRequest) =>
            invoker(apiParams.uri, data),
    ];
}
